import React, { useEffect, useState, useCallback } from 'react'
import {Link} from 'react-router-dom'
import { Table, Container,Jumbotron } from 'react-bootstrap';
import Compiler from './components/compiler/compiler'

const EditQuestion = ({location}) =>{
    const [uniqueId, setUniqueId] = useState([])
    // const [questionData, setQuestionData] = useState()
    const [description, setDescripition] = useState()
    const [constraints, setConstraints] = useState()
    const [inputFormat, setInputFormat] = useState()
    const [outputFormat, setOutputFormat] = useState()
    const [example1, setExample1] = useState()
    const [example2, setExample2] = useState()
    const [input1,setInput1] = useState()
    const [output1,setOutput1] = useState()
    const [input2,setInput2] = useState()
    const [output2,setOutput2] = useState()
    const [testCasesData, setTestCasesData] = useState({})
    const [testCaseInput, setTestCaseInput] = useState()
    const [testCaseOutput, setTestCaseOutput] = useState()
    
    const [loader, setLoader] = useState(true)
    const [loaderForTestCase, setLoaderForTestCase] = useState(false)
    
    const loadData = useCallback(async () =>{
        setLoader(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UQI")
    
        var tempArr = temp2.split("@")
        setUniqueId(tempArr)
        const response = await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/questions/${tempArr[0]}.json`)
        const resData = await response.json()
        
        
        if(resData){
            
            await setDescripition(resData.description)
            await setConstraints(resData.constraints)
            await setInputFormat(resData.inputFormat)
            await setOutputFormat(resData.outputFormat)
            await setExample1(resData.example1)
            await setExample2(resData.example2)
            await setInput1(resData.sampeInput1)
            await setOutput1(resData.sampeOutput1)
            await setInput2(resData.sampeInput2)
            await setOutput2(resData.sampeOutput2)
            if(resData.testCases){
                await setTestCasesData(resData.testCases)
            }
        }
        
        
        setLoader(false)
        
        
       
        
    },[location.search])

    

    useEffect(() =>{
        loadData()
    },[loadData])

    const onChange = (value, item) =>{
        if(item === "description"){
            setDescripition(value)
        }
        if(item === "Constraints"){
            setConstraints(value)
        }
        if(item === "InputFormat"){
            setInputFormat(value)
        }
        if(item === "OutputFormat"){
            setOutputFormat(value)
        }
        if(item === "example1"){
            setExample1(value)
        }
        if(item === "example2"){
            setExample2(value)
        }
        if(item === "input1"){
            setInput1(value)
        }
        if(item === "output1"){
            setOutput1(value)
        }
        if(item === "input2"){
            setInput2(value)
        }
        if(item === "output2"){
            setOutput2(value)
        }
        if(item === "testCaseInput"){
            setTestCaseInput(value)
        }
        if(item === "testCaseOutput"){
            setTestCaseOutput(value)
        }
    }
    

    const saveHandler = async() =>{
        setLoader(true)
        if(description  &&
            constraints &&
            inputFormat &&
            outputFormat &&
            example1 &&
            example2){
                const params = new URLSearchParams(location.search)
                const temp2 = params.get("UQI")
                var tempArr = temp2.split("@")
            await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/questions/${tempArr[0]}.json`,{
                    method:'PATCH',
                    headers:{
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify({
                    "description":description,
                    "constraints":constraints,
                    "inputFormat":inputFormat,
                    "outputFormat":outputFormat,
                    "example1":example1,
                    "example2":example2,
                    "sampeInput1":input1,
                    "sampeOutput1":output1,
                    "sampeInput2":input2,
                    "sampeOutput2":output2
                    })
                })
          loadData()
          
          
            }
            setLoader(false)
    }

    function makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const addTestCaseHandler = async() => {
        setLoaderForTestCase(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UQI")
        var tempArr = temp2.split("@")
        const uID = makeid(3)
        await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/questions/${tempArr[0]}/testCases.json`,{
                    method:'PATCH',
                    headers:{
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify({
                        [uID]: [testCaseInput, testCaseOutput]
                    })
                })
        var Map = testCasesData
        Map[uID] = {
            0:testCaseInput,
            1:testCaseOutput
        }
        setTestCasesData(Map)  
        setLoaderForTestCase(false)
    }
    const deleteTestCaseHandler = async(uId) => {
        setLoaderForTestCase(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UQI")
        var tempArr = temp2.split("@")
        await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/questions/${tempArr[0]}/testCases/${uId}.json`,{
            method:"DELETE"
        })
        var Map = testCasesData
        delete Map[uId]
        setTestCasesData(Map)

        setLoaderForTestCase(false)
    }

    return (
        <section className = "hero">
            
            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        
                        <Link to = {'/contests?UCI='+ uniqueId[1]} style = {{color:"white"}}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style = {{fontSize:"40px"}}></i>
                        </Link>
                        <div>
                        
                        
                        {loader ? <p></p>:<h1 style = {{color:"white"}}> {uniqueId[0].split("_").join(" ").substring(0, uniqueId[0].split("_").join(" ").length - 4)}</h1>}
                        </div>
                    </div>
                </nav>
            </header> 
            
            {   loader ? <h1>Loading</h1> :
                <Container style = {{marginTop:"2%"}}>
                    <h3 style = {{fontWeight:"bold"}}> Description</h3>
                    <hr />
                    <textarea
                    
                    style = {{width:"100%",height:"200px"}}
                    value = {description}
                    onChange={(e) => onChange(e.target.value,"description")}
                    // id = "source"
                    autoCorrect = "off"
                    autoCapitalize = "none"
                    spellCheck = "false"
                    tabIndex = "0"
                    wrap = "off"
                    />
                   
                    <br/>
                    <h3 style = {{fontWeight:"bold"}}>Constraints</h3>
                    <hr />
                    <textarea
                    
                    style = {{width:"100%",height:"100px"}}
                    value = {constraints}
                    onChange={(e) => onChange(e.target.value,"Constraints")}
                    // id = "source"
                    autoCorrect = "off"
                    autoCapitalize = "none"
                    spellCheck = "false"
                    tabIndex = "0"
                    wrap = "off"
                    />
                    
                    <br />
                    <br />
                    <h3 style = {{fontWeight:"bold"}}>Input Format</h3>
                    <hr />
                    <textarea
                    
                    style = {{width:"100%",height:"80px"}}
                    value = {inputFormat}
                    onChange={(e) => onChange(e.target.value,"InputFormat")}
                    // id = "source"
                    autoCorrect = "off"
                    autoCapitalize = "none"
                    spellCheck = "false"
                    tabIndex = "0"
                    wrap = "off"
                    />
                    
                    <br/>
                    <h3 style = {{fontWeight:"bold"}}>Output Format</h3>
                    <hr />
                    <textarea
                    
                    style = {{width:"100%",height:"80px"}}
                    value = {outputFormat}
                    onChange={(e) => onChange(e.target.value,"OutputFormat")}
                    // id = "source"
                    autoCorrect = "off"
                    autoCapitalize = "none"
                    spellCheck = "false"
                    tabIndex = "0"
                    wrap = "off"
                    />
                   
                    <br />
                    <br />
                    <h3 style = {{fontWeight:"bold"}}>Examples</h3>
                    <hr />
                    
                    <h4 style = {{fontWeight:"bold"}}>Example 1</h4>
                    <br />
                    <Jumbotron>
                        <textarea
                        
                        style = {{width:"100%",height:"80px"}}
                        value = {example1}
                        onChange={(e) => onChange(e.target.value,"example1")}
                        // id = "source"
                        autoCorrect = "off"
                        autoCapitalize = "none"
                        spellCheck = "false"
                        tabIndex = "0"
                        wrap = "off"
                        />
                       
                    </Jumbotron>
                    <br/>

                    <h4 style = {{fontWeight:"bold"}}>Example 2</h4>
                    <br />
                    <Jumbotron>
                        <textarea
                            
                        style = {{width:"100%",height:"80px"}}
                        value = {example2}
                        onChange={(e) => onChange(e.target.value,"example2")}
                        // id = "source"
                        autoCorrect = "off"
                        autoCapitalize = "none"
                        spellCheck = "false"
                        tabIndex = "0"
                        wrap = "off"
                        />
                        
                    </Jumbotron>

                    
                    <br />
                    <Compiler />
                    
                    <h3 style = {{fontWeight:"bold"}}>Sample test case 1</h3>
                    <hr />
                    <div style = {{display:"flex",flexDirection:"row"}}>
                        <div style = {{display:"flex",flexDirection:"column"}}>
                        <h4>Input</h4>
                        <textarea
                            
                            
                            value = {input1}
                            onChange={(e) => onChange(e.target.value,"input1")}
                            id = "input1"
                            autoCorrect = "off"
                            autoCapitalize = "none"
                            spellCheck = "false"
                            tabIndex = "0"
                            wrap = "off"
                        />
                        </div>
                        <div style = {{display:"flex",flexDirection:"column", marginLeft:"2%"}}>
                        <h4>Ouput</h4>
                        
                        <textarea
                            
                            
                            value = {output1}
                            onChange={(e) => onChange(e.target.value,"output1")}
                            id = "output1"
                            autoCorrect = "off"
                            autoCapitalize = "none"
                            spellCheck = "false"
                            tabIndex = "0"
                            wrap = "off"
                        />
                        </div>
                    </div>
                    
                    <br />

                    <h3 style = {{fontWeight:"bold"}}>Sample test case 2</h3>
                    <hr />
                    <div style = {{display:"flex",flexDirection:"row"}}>
                        <div style = {{display:"flex",flexDirection:"column"}}>
                        <h4>Input</h4>
                        <textarea
                            
                            
                            value = {input2}
                            onChange={(e) => onChange(e.target.value,"input2")}
                            id = "input2"
                            autoCorrect = "off"
                            autoCapitalize = "none"
                            spellCheck = "false"
                            tabIndex = "0"
                            wrap = "off"
                        />
                        </div>
                        <div style = {{display:"flex",flexDirection:"column", marginLeft:"2%"}}>
                        <h4>Ouput</h4>
                        <textarea
                            
                            
                            value = {output2}
                            onChange={(e) => onChange(e.target.value,"output2")}
                            id = "output2"
                            autoCorrect = "off"
                            autoCapitalize = "none"
                            spellCheck = "false"
                            tabIndex = "0"
                            wrap = "off"
                        />
                        </div>
                    </div>
                    <br />
                    <br />
                    <h3 style = {{fontWeight:"bold"}}>Add Test Cases</h3>
                    <hr />  


                    <Table striped bordered >
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Input</th>
                            <th>Expected Output</th>
                            <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            { loaderForTestCase ? 
                                <tr>
                                    <td>1</td>
                                    <td>Loading</td>
                                    <td>.</td>
                                    <td>.</td>
                                </tr> :
                                Object.keys(testCasesData).map((item,i) => 
                                    <tr key = {item}>
                                        <td>{i}</td>
                                        <td>
                                            <textarea 
                                                className='autoExpand textarea1' 
                                                rows="4"
                                                
                                                readOnly
                                                style = {{
                                                    width:"100%",
                                                    backgroundColor:"#e9ecef",
                                                    boxSizing: "border-box  !important",
                                                    border: "none !important",
                                                    borderRadius:" 3px !important",
                                                    resize: "none !important",
                                                    fontSize: "20px !important",
                                                    lineHeight: "24px !important",
                                                    overflow: "auto !important",
                                                    height: "auto !important",
                                                    padding: "8px !important",
                                                    
                                                    }}
                                                value = {testCasesData[item][0]}
                                                
                                            />
                                        </td>
                                        <td>
                                            <textarea 
                                                className='autoExpand textarea1' 
                                                rows="4"
                                                
                                                readOnly
                                                style = {{
                                                    width:"100%",
                                                    backgroundColor:"#e9ecef",
                                                    boxSizing: "border-box  !important",
                                                    border: "none !important",
                                                    borderRadius:" 3px !important",
                                                    resize: "none !important",
                                                    fontSize: "20px !important",
                                                    lineHeight: "24px !important",
                                                    overflow: "auto !important",
                                                    height: "auto !important",
                                                    padding: "8px !important",
                                                    
                                                    }}
                                                value = {testCasesData[item][1]}
                                                
                                            />
                                        </td>
                                        <td>
                                        <button className = "btn btn-danger"  style = {{margin:"1%"}} onClick = {() =>deleteTestCaseHandler(item)}>Delete</button>  
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                        </Table>
                            
                            <hr/>
                            
                            <div style = {{display:"flex",flexDirection:"row"}}>
                                <div style = {{display:"flex",flexDirection:"column"}}>
                                <h4>Input</h4>
                                <textarea
                                    
                                    
                                    value = {testCaseInput}
                                    onChange={(e) => onChange(e.target.value,"testCaseInput")}
                                    
                                    autoCorrect = "off"
                                    autoCapitalize = "none"
                                    spellCheck = "false"
                                    tabIndex = "0"
                                    wrap = "off"
                                />
                                </div>
                                <div style = {{display:"flex",flexDirection:"column", marginLeft:"2%"}}>
                                <h4>Ouput</h4>
                                <textarea
                                    
                                    
                                    value = {testCaseOutput}
                                    onChange={(e) => onChange(e.target.value,"testCaseOutput")}
                                    
                                    autoCorrect = "off"
                                    autoCapitalize = "none"
                                    spellCheck = "false"
                                    tabIndex = "0"
                                    wrap = "off"
                                />
                                </div>
                            </div>
                    <button className = "btn btn-success"  onClick = {addTestCaseHandler}  style = {{width:"20%",margin:"2%",marginLeft:"71%"}}>Add</button>  
                    <br />
                    <hr />
                    <br />
                    <button className = "btn btn-success" onClick = {saveHandler}  style = {{width:"20%",margin:"2%",marginLeft:"71%"}}>Save</button>  
                </Container>
            }
           
        </section>
    )
}

export default EditQuestion;